import { useAntDesignTheme } from './useAntDesignTheme';

export const useNivoChartTheme = () => {
    const { token, resolvedThemeName } = useAntDesignTheme();

    const nivoChartTheme = {
        background: token.colorBgContainer,
        text: {
            fontSize: 11,
            fill: token.colorTextSecondary,
            outlineWidth: 0,
            outlineColor: 'transparent',
        },
        textColor: token.colorTextSecondary,
        axis: {
            // domain: {
            //     line: {
            //         stroke: token.colorBorder,
            //         strokeWidth: 1,
            //     },
            // },
            legend: {
                text: {
                    fontSize: 12,
                    fill: token.colorTextSecondary,
                    outlineWidth: 0,
                    outlineColor: 'transparent',
                },
            },
            ticks: {
                line: {
                    stroke: token.colorBorder,
                    strokeWidth: 1,
                },
                text: {
                    fontSize: 11,
                    fill: token.colorTextSecondary,
                    outlineWidth: 0,
                    outlineColor: 'transparent',
                },
            },
        },
        legends: {
            title: {
                text: {
                    fontSize: 11,
                    fill: token.colorTextSecondary,
                    outlineWidth: 0,
                    outlineColor: 'transparent',
                },
            },
            text: {
                fontSize: 11,
                fill: token.colorTextSecondary,
                outlineWidth: 0,
                outlineColor: 'transparent',
            },
            ticks: {
                line: {},
                text: {
                    fontSize: 10,
                    fill: token.colorTextSecondary,
                    outlineWidth: 0,
                    outlineColor: 'transparent',
                },
            },
        },
        annotations: {
            text: {
                fontSize: 13,
                fill: token.colorTextSecondary,
                outlineWidth: 2,
                outlineColor: token.colorBgContainer,
                outlineOpacity: 1,
            },
            link: {
                stroke: token.colorTextSecondary,
                strokeWidth: 1,
                outlineWidth: 2,
                outlineColor: token.colorBgContainer,
                outlineOpacity: 1,
            },
            outline: {
                stroke: token.colorTextSecondary,
                strokeWidth: 2,
                outlineWidth: 2,
                outlineColor: token.colorBgContainer,
                outlineOpacity: 1,
            },
            symbol: {
                fill: token.colorTextSecondary,
                outlineWidth: 2,
                outlineColor: token.colorBgContainer,
                outlineOpacity: 1,
            },
        },
        grid: { line: { stroke: token.colorBorder } },
        tooltip: {
            container: {
                background: token.colorBgContainer,
                color: token.colorText,
                fontSize: '16px',
                padding: '0.25rem 0.5rem',
                boxShadow: token.boxShadow,
                border: `1px solid ${token.colorBorder}`,
                borderRadius: token.borderRadius,
            },
        },
    };

    // https://github.com/plouc/nivo/issues/1815#issuecomment-988073530
    const colorsArray =
        resolvedThemeName === 'dark'
            ? [
                  token.blue6,
                  token.green6,
                  token.gold6,
                  token.red6,
                  token.cyan6,
                  token.purple6,
                  token.yellow6,
                  token.geekblue6,
                  token.volcano6,
                  token.lime6,
                  token.magenta6,
                  token.orange6,
              ]
            : [
                  token.blue4,
                  token.green4,
                  token.gold4,
                  token.red4,
                  token.cyan4,
                  token.purple4,
                  token.yellow4,
                  token.geekblue4,
                  token.volcano4,
                  token.lime4,
                  token.magenta4,
                  token.orange4,
              ];

    return { nivoChartTheme, colorsArray };
};
